var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 16 16",
    fill: "#008080",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.98669 4.53589C9.23718 4.53589 10.2546 3.51843 10.2546 2.26794C10.2546 1.01746 9.23718 0 7.98669 0C6.73621 0 5.71875 1.01746 5.71875 2.26794C5.71875 3.51843 6.73621 4.53589 7.98669 4.53589Z",
    fill: "#008080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98669 5.73206C6.73621 5.73206 5.71875 6.74951 5.71875 8C5.71875 9.25049 6.73621 10.2679 7.98669 10.2679C9.23718 10.2679 10.2546 9.25049 10.2546 8C10.2546 6.74951 9.23718 5.73206 7.98669 5.73206Z",
    fill: "#008080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98669 11.4641C6.73621 11.4641 5.71875 12.4816 5.71875 13.7321C5.71875 14.9827 6.73621 16 7.98669 16C9.23718 16 10.2546 14.9827 10.2546 13.7321C10.2546 12.4816 9.23718 11.4641 7.98669 11.4641Z",
    fill: "#008080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#008080"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.f08b041d7087ff6b89119eff091d4025.svg";
export { ForwardRef as ReactComponent };